import component from "./src/select";
component.install = function(Vue) {
  Vue.component(component.name, component);
};
export default component;
